import { Grid } from '@material-ui/core'
import CardView from './CardView'

export const CardIterator = ({
  data,
  isLoading,
  setOpenDetail,
  openDetail,
  coproprietaire_id,
  copro_id,
  setFile,
}) => {
  if (isLoading) {
    return (
      <Grid
        item
        xs={12}
        style={{
          minHeight: '200px',
          background: 'white',
          fontSize: '22px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        Loading ...
      </Grid>
    )
  }

  if (!data) {
    return null
  }

  return (
    <div>
      {data.map((record) => (
        <CardView
          key={record.id}
          record={record}
          setOpenDetail={setOpenDetail}
          openDetail={openDetail}
          coproprietaire_id={coproprietaire_id}
          copro_id={copro_id}
          setFile={setFile}
        />
      ))}
    </div>
  )
}
export default CardIterator
